export default __webpack_public_path__ + "static/media/banner-seu-futuro.ca01f345.png";